import * as angular from "angular";

import type {
	FormMessageVariant,
	FormUiSchema
} from "../types";
import markdown from "./markdown";
import template from "./label.html";

const messageVariants: readonly FormMessageVariant[] = [
	"info",
	"success",
	"warning",
	"error"
];

export interface LabelController {
	ui: FormUiSchema;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class LabelController implements angular.IController {
	public content = "";

	public noticeClass = "";

	public $onChanges(): void {
		this.content = typeof this.ui?.text === "string" ? this.ui.text : "";
		const variant = this.ui?.options?.variant;
		this.noticeClass = variant && messageVariants.includes(variant)
			? variant
			: "";
	}
}

export default angular.module("vesl.extensions.json-schema.label", [markdown])
	.component("jsonSchemaLabel", {
		template,
		controller: LabelController,
		bindings: { ui: "<" }
	})
	.name;
